import { httpV2 } from "@/api/index";

/**
 * Solicita o diagnóstico de entreferro.
 * @param {number} resultId Id do resultado geral do modo de falha.
 * @returns {promise} Retorna status do diagnóstico.
 */
const GetDiagnostics = function(resultId)
{
	return httpV2.get(`/HydroGeneratingUnitDiagnostic/${resultId}/AirGap`);
};

export default { GetDiagnostics };